export default {
    /**
     * Returns the Jaama monthly BiK whose rate matches the driver's income-tax band, or 0 if no band matches.
     *
     * @param {object} vehicle - The Jaama quote details object.
     * @param {number|string} taxRate - The driver's income-tax band rate percent.
     * @returns {number}
     */
    getVehicleBikByRate: function(vehicle, taxRate) {
        const rate = parseInt(taxRate);
        if (vehicle.biK1Rate === rate) {
            return vehicle.biK1;
        } else if (vehicle.biK2Rate === rate) {
            return vehicle.biK2;
        } else if (vehicle.biK3Rate === rate) {
            return vehicle.biK3;
        } else if (vehicle.biK4Rate === rate) {
            return vehicle.biK4;
        } else if (vehicle.biK5Rate === rate) {
            return vehicle.biK5;
        } else if (vehicle.biK6Rate === rate) {
            return vehicle.biK6;
        }

        return 0;
    }
}
